exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".full-page-loader[data-v-71e4632f]{min-height:80vh}\n", ""]);
